import React from "react";
import { useQuery } from "@apollo/client";
import { Box, Container, Typography } from "@mui/material";
import { PRODUCT_INTRO_QUERY } from "../graphql/pageIntros";

type Props = {
  productId: string;
};

export default function ProductIntroSection({ productId }: Props) {
  const { data } = useQuery(PRODUCT_INTRO_QUERY, {
    variables: { productId },
    fetchPolicy: "cache-and-network",
    skip: !productId,
  });

  const intro = data?.productIntro;
  if (!intro?.content) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        py: { xs: 5, md: 8 },
        borderTop: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            fontSize: { xs: ".9rem", md: "1rem" },
            lineHeight: 1.85,
            color: "text.primary",
            "& p": { mb: 2 },
            "& h1, & h2, & h3": {
              fontFamily: `"Bodoni Moda", serif`,
              mb: 1.5,
            },
            "& ul, & ol": { pl: 3, mb: 2 },
            "& a": { color: "#1976d2", textDecoration: "underline" },
            "& strong": { fontWeight: 700 },
            "& em": { fontStyle: "italic" },
          }}
          dangerouslySetInnerHTML={{ __html: intro.content }}
        />
      </Container>
    </Box>
  );
}
